/**
 * Canonical event keywords for tenant_id = learnwise.
 * Used to match metadata in events_attended and display cleaner labels on the People page.
 * Source: canonical_event_keywords.txt
 */

export const LEARNWISE_CANONICAL_EVENT_KEYWORDS = [
  'ASCILITE',
  'EDUtech',
  'Bett',
  'SITE',
  'LAK',
  'ECTEL',
  'ICCE',
  'FLAIEC',
  'FUTUREDUCA',
  'INNDOC',
  'CONTE',
  'ICWL-SETE',
  'HEDx',
  'AI for Education',
  'IFE Conference',
  'Digital Universities',
  'EDUINNOV',
  'EDUTIC',
  'Global Smart Education',
  'Higher Education Technology Summit',
  'Encuentro Iberoamericano EdTech',
  'ASU+GSV Summit',
  'Anthology Together',
  'MoodleMoot',
  'InstructureCon',
  'D2L Fusion',
  'Turnitin',
  'THE',
  'QS',
  'UA Solutions Summit',
  'APRU',
  'Universitas 21',
  'ASAIHL',
  'CGS',
  'iUNRC',
  'Congreso HOPE',
  'ASU-Cintana',
  'MENA HE Forum',
  'Congreso Futuro',
  'World Economic Forum',
  'Global University Presidents Summit',
  'CIPRI',
  'Asian Science Deans Forum',
  'ACDS',
  'ANUIES',
  'ANDIFES',
  'CONAE',
  'CLABES',
  'Encuentro de Rectores',
  'ANPAE / SBPAE',
  'Encuentro Educación a Distancia',
  'CIAED',
  'SENAED',
  'ESUD',
  'ICDE',
  'OE Global',
  'IEEE',
  'ACM',
  'ACL',
  'AAAI',
  'ICML',
  'ICSE',
  'ICIS',
  'SBC',
  'SBPC',
  'SBFoton',
  'COBEQ / ENBEQ',
  'TEQSA',
  'Encuentro Mejora Continua',
  'EFMD',
  'AACSB',
  'CAUDIT',
  'CAULLT',
  'HERDSA',
  'HETL',
  'HKTEA',
  'TESSI',
  'Eportfolio Forum',
  'Student Wellbeing Symposium',
  'Global Virtual Exchange Summit',
  'IAMSE',
  'AAMC',
  'ANFEI',
  'ASET',
  'NEEdS',
  'Cyber Conference',
  'ReThink',
  'ICBS',
  'ASEAN Blue Economy',
  'Green Tech Summit',
  'CDOIQ',
  'ITU AI for Good',
  'SAIAConf',
  'SCAI',
  'HUN-REN AI Symposium',
  'National AI Summit/Expo',
  'Openmind AI',
  'GESDA',
  'Consensus',
  'KubeCon',
  'PyCon',
  'eResearch',
  'OZCHI',
  'FIL Guadalajara',
  'Integridad Académica',
  'Conferência Nacional de CTI',
  'InnovFest',
  'BIOHK',
  'Caribbean Prime Ministers',
  'Social Enterprise Summit',
  'Philippine Computing Science Congress',
  'PAAI',
  'IB Conference',
  'Career Practitioners Conference',
  'Elsevier Research Summit',
  'UAL Education Conference',
  'OTA National Conference',
  'ABEC Meeting',
  'ABCF Congress',
  'Enastic',
  'Singapore Health and Biomedical Congress',
  'EMBA Frontier Forum',
  'International Halal Symposium',
  'Encuentro Universidad como Objeto',
  'SIEP',
  'Mujeres en Ciencia',
  'ABEMA',
  'CNSM',
  'COAT',
  'English Across the Curriculum',
  'ICGCED',
  'ICSR',
  'IUMRS-ICEM',
  'Transparencia y Gobierno Abierto',
  'Automated Enterprise Summit',
  'Global Anti-Scam Summit',
  'Los Futuros de la Educación',
  'Congreso Científico-Profesional',
  'Jornadas de Derecho',
  'Societal Impact of AI',
  'Legal Research Conference',
  'Engineering Practice Research',
];

// Sort by length descending so longer keywords match first (e.g. "AI for Education" before "AI")
const KEYWORDS_BY_LENGTH = [...LEARNWISE_CANONICAL_EVENT_KEYWORDS].sort(
  (a, b) => b.length - a.length
);

/**
 * Maps a raw event string to a canonical keyword for learnwise.
 * Uses case-insensitive substring matching; longer keywords are checked first.
 * @param {string} rawEvent - Raw event string from events_attended
 * @returns {string|null} Canonical keyword if matched, null otherwise
 */
export function matchLearnwiseEventToKeyword(rawEvent) {
  if (!rawEvent || typeof rawEvent !== 'string') return null;
  const normalized = rawEvent.trim();
  if (!normalized) return null;
  const lower = normalized.toLowerCase();
  for (const kw of KEYWORDS_BY_LENGTH) {
    if (kw && lower.includes(kw.toLowerCase())) return kw;
  }
  return null;
}

/**
 * Returns the display label for a raw event on the People page (learnwise only).
 * Uses canonical keyword if matched, otherwise returns raw.
 */
export function getLearnwiseEventDisplayLabel(rawEvent) {
  const keyword = matchLearnwiseEventToKeyword(rawEvent);
  return keyword || rawEvent;
}
